import {
  IAccountsGivenUserResponse,
  IEntitlementsGivenBrResponse,
  IEntitlementsGivenOuResponse,
  IEntitlementsGivenUserResponse,
  IGetAccountTabListResponse,
  IGetBRTabListResponse,
  IGetEntitlementTabListResponse,
  IGetOUTabListResponse,
  IGetTechnicalUserTabListResponse,
  IGetUserTabListResponse,
  IUsersGivenEntitlementResponse,
} from "../CertificationReferenceStepTwo/module/constants";
import { IFetchMassiveBody } from "./constants";

export const actionTypes = {
  SET_CAMPAIGN_ACCESS_ROLE: "SET_CAMPAIGN_ACCESS_ROLE",
  SET_IMPERSONIFICATION: "SET_IMPERSONIFICATION",
  SET_SELECTED_CERTIFICATION: "SET_SELECTED_CERTIFICATION",
  SET_CAMPAIGN_CONFIG: "SET_CAMPAIGN_CONFIG",
  CERTIFICATION_REQUEST: "CERTIFICATION_REQUEST",
  CERTIFICATION_REQUEST_SUCCESS: "CERTIFICATION_REQUEST_SUCCESS",
  CERTIFICATION_REQUEST_FAILURE: "CERTIFICATION_REQUEST_FAILURE",

  SELECT_ITEM: "SELECT_ITEM",
  SELECT_ITEM_DETAIL: "SELECT_ITEM_DETAIL",

  GET_CAMPAIGN_INFO: "GET_CAMPAIGN_INFO",
  GET_CAMPAIGN_INFO_SUCCESS: "GET_CAMPAIGN_INFO_SUCCESS",
  GET_CAMPAIGN_INFO_FAILURE: "GET_CAMPAIGN_INFO_FAILURE",

  GET_CAMPAIGN_REVISORS: "GET_CAMPAIGN_REVISORS",
  GET_CAMPAIGN_REVISORS_SUCCESS: "GET_CAMPAIGN_REVISORS_SUCCESS",
  GET_CAMPAIGN_REVISORS_FAILURE: "GET_CAMPAIGN_REVISORS_FAILURE",

  GET_EDIT_REVISOR_REQUEST: "GET_EDIT_REVISOR_REQUEST",
  GET_EDIT_REVISOR_REQUEST_SUCCESS: "GET_EDIT_REVISOR_REQUEST_SUCCESS",
  GET_EDIT_REVISOR_REQUEST_FAILURE: "GET_EDIT_REVISOR_REQUEST_FAILURE",

  EDIT_CAMPAIGN_REQUEST: "EDIT_CAMPAIGN_REQUEST",
  EDIT_CAMPAIGN_REQUEST_SUCCESS: "EDIT_CAMPAIGN_REQUEST_SUCCESS",
  EDIT_CAMPAIGN_REQUEST_FAILURE: "EDIT_CAMPAIGN_REQUEST_FAILURE",

  SET_CONFIRM_EXECUTION: "SET_CONFIRM_EXECUTION",

  KEEP_ITEMS_REQUEST: "KEEP_ITEMS_REQUEST",
  KEEP_ITEMS_REQUEST_SUCCESS: "KEEP_ITEMS_REQUEST_SUCCESS",
  KEEP_ITEMS_REQUEST_FAILURE: "KEEP_ITEMS_REQUEST_FAILURE",

  REVOKE_ITEMS_REQUEST: "REVOKE_ITEMS_REQUEST",
  REVOKE_ITEMS_REQUEST_SUCCESS: "REVOKE_ITEMS_REQUEST_SUCCESS",
  REVOKE_ITEMS_REQUEST_FAILURE: "REVOKE_ITEMS_REQUEST_FAILURE",

  VALIDATE_ITEMS_REQUEST: "VALIDATE_ITEMS_REQUEST",
  VALIDATE_ITEMS_REQUEST_SUCCESS: "VALIDATE_ITEMS_REQUEST_SUCCESS",
  VALIDATE_ITEMS_REQUEST_FAILURE: "VALIDATE_ITEMS_REQUEST_FAILURE",
  RESET_STATE_STEP_ONE: "RESET_STATE_STEP_ONE",

  FETCH_CLOSE_CERTIFICATION: "FETCH_CLOSE_CERTIFICATION",
  FETCH_CLOSE_CERTIFICATION_SUCCESS: "FETCH_CLOSE_CERTIFICATION_SUCCESS",
  FETCH_CLOSE_CERTIFICATION_FAILURE: "FETCH_CLOSE_CERTIFICATION_FAILURE",

  FETCH_SEND_CERTIFICATION_REMINDER: "FETCH_SEND_CERTIFICATION_REMINDER",
  FETCH_SEND_CERTIFICATION_REMINDER_SUCCESS:
    "FETCH_SEND_CERTIFICATION_REMINDER_SUCCESS",
  FETCH_SEND_CERTIFICATION_REMINDER_FAILURE:
    "FETCH_SEND_CERTIFICATION_REMINDER_FAILURE",

  FETCH_CLOSE_CERTIFICATION_ITEM: "FETCH_CLOSE_CERTIFICATION_ITEM",
  FETCH_CLOSE_CERTIFICATION_ITEM_SUCCESS:
    "FETCH_CLOSE_CERTIFICATION_ITEM_SUCCESS",
  FETCH_CLOSE_CERTIFICATION_ITEM_FAILURE:
    "FETCH_CLOSE_CERTIFICATION_ITEM_FAILURE",

  FETCH_UPDATE_REVISOR: "FETCH_UPDATE_REVISOR",
  FETCH_UPDATE_REVISOR_SUCCESS: "FETCH_UPDATE_REVISOR_SUCCESS",
  FETCH_UPDATE_REVISOR_FAILURE: "FETCH_UPDATE_REVISOR_FAILURE",
  UPDATE_AGGREGATE_OU_REVISOR_REQUEST: "UPDATE_AGGREGATE_OU_REVISOR_REQUEST",
  UPDATE_AGGREGATE_OU_REVISOR_REQUEST_SUCCESS:
    "UPDATE_AGGREGATE_OU_REVISOR_REQUEST_SUCCESS",
  UPDATE_AGGREGATE_OU_REVISOR_REQUEST_FAILURE:
    "UPDATE_AGGREGATE_OU_REVISOR_REQUEST_FAILURE",
  UPDATE_AGGREGATE_USER_REVISOR_REQUEST:
    "UPDATE_AGGREGATE_USER_REVISOR_REQUEST",
  UPDATE_AGGREGATE_USER_REVISOR_REQUEST_SUCCESS:
    "UPDATE_AGGREGATE_USER_REVISOR_REQUEST_SUCCESS",
  UPDATE_AGGREGATE_USER_REVISOR_REQUEST_FAILURE:
    "UPDATE_AGGREGATE_USER_REVISOR_REQUEST_FAILURE",
  UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST:
    "UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST",
  UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_SUCCESS:
    "UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_SUCCESS",
  UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_FAILURE:
    "UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_FAILURE",
  UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST:
    "UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST",
  UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_SUCCESS:
    "UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_SUCCESS",
  UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_FAILURE:
    "UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_FAILURE",

  FETCH_REOPEN_ITEM: "FETCH_REOPEN_ITEM",
  FETCH_REOPEN_ITEM_SUCCESS: "FETCH_REOPEN_ITEM_SUCCESS",
  FETCH_REOPEN_ITEM_FAILURE: "FETCH_REOPEN_ITEM_FAILURE",

  SET_IS_CURRENT_USER_ADMIN: "SET_IS_CURRENT_USER_ADMIN",
  SET_IS_CURRENT_USER_SUPERVISOR: "SET_IS_CURRENT_USER_SUPERVISOR",

  EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST:
    "EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST",
  EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_FAILURE",
  EDIT_PERIMETER_SET_ADDED_GROUPS_PERIMETER:
    "EDIT_PERIMETER_SET_ADDED_GROUPS_PERIMETER",
  EDIT_PERIMETER_SET_TAB_SELECTED: "EDIT_PERIMETER_SET_TAB_SELECTED",
  SET_ADDED_SUPERVISORS_CERTIFICATION_REFERENCE:
    "SET_ADDED_SUPERVISORS_CERTIFICATION_REFERENCE",
  SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE:
    "SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE",
  SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_SUCCESS:
    "SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_SUCCESS",
  SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_FAILURE:
    "SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_FAILURE",

  EDIT_PERIMETER_OWNERSHIP_SET_ADDED_ENTITLEMENTS_PERIMETER:
    "EDIT_PERIMETER_OWNERSHIP_SET_ADDED_ENTITLEMENTS_PERIMETER",
  EDIT_PERIMETER_OWNERSHIP_SET_TAB_SELECTED:
    "EDIT_PERIMETER_OWNERSHIP_SET_TAB_SELECTED",
  EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST:
    "EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST",
  EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_FAILURE",
  SET_TRIGGER_CONFIRM_MODAL_EDIT_PERIMETER:
    "SET_TRIGGER_CONFIRM_MODAL_EDIT_PERIMETER",
  EDIT_PERIMETER_USERS_PERIMETER_REQUEST:
    "EDIT_PERIMETER_USERS_PERIMETER_REQUEST",
  EDIT_PERIMETER_USERS_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_USERS_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_USERS_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_USERS_PERIMETER_REQUEST_FAILURE",
  EDIT_PERIMETER_SET_ADDED_USERS_PERIMETER:
    "EDIT_PERIMETER_SET_ADDED_USERS_PERIMETER",
  EDIT_PERIMETER_USERS_SET_TAB_SELECTED:
    "EDIT_PERIMETER_USERS_SET_TAB_SELECTED",

  EDIT_PERIMETER_BR_PERIMETER_REQUEST: "EDIT_PERIMETER_BR_PERIMETER_REQUEST",
  EDIT_PERIMETER_BR_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_BR_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_BR_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_BR_PERIMETER_REQUEST_FAILURE",
  SET_ADDED_BR_PERIMETER: "SET_ADDED_BR_PERIMETER",

  EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST:
    "EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST",
  EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_FAILURE",
  SET_ADDED_APPLICATIONS_PERIMETER: "SET_ADDED_APPLICATIONS_PERIMETER",

  EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST:
    "EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST",
  EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_SUCCESS:
    "EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_SUCCESS",
  EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_FAILURE:
    "EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_FAILURE",
  SET_ADDED_TECHNICAL_USERS_PERIMETER: "SET_ADDED_TECHNICAL_USERS_PERIMETER",

  SET_TRIGGER_CONFIRM_MODAL_CERTIFICATION_REFERENCE:
    "SET_TRIGGER_CONFIRM_MODAL_CERTIFICATION_REFERENCE",

  GET_USER_TAB_LIST: "GET_USER_TAB_LIST",
  GET_OU_TAB_LIST: "GET_OU_TAB_LIST",
  GET_BR_TAB_LIST: "GET_BR_TAB_LIST",
  GET_ENTITLEMENT_TAB_LIST: "GET_ENTITLEMENT_TAB_LIST",
  GET_ACCOUNT_TAB_LIST: "GET_ACCOUNT_TAB_LIST",
  GET_TECHNICAL_USER_TAB_LIST: "GET_TECHNICAL_USER_TAB_LIST",
  GET_ITEM_TAB_LIST: "GET_ITEM_TAB_LIST",

  GET_USER_TAB_LIST_SUCCESS: "GET_USER_TAB_LIST_SUCCESS",
  GET_OU_TAB_LIST_SUCCESS: "GET_OU_TAB_LIST_SUCCESS",
  GET_BR_TAB_LIST_SUCCESS: "GET_BR_TAB_LIST_SUCCESS",
  GET_ENTITLEMENT_TAB_LIST_SUCCESS: "GET_ENTITLEMENT_TAB_LIST_SUCCESS",
  GET_ACCOUNT_TAB_LIST_SUCCESS: "GET_ACCOUNT_TAB_LIS_SUCCESS",
  GET_TECHNICAL_USER_TAB_LIST_SUCCESS: "GET_TECHNICAL_USER_TAB_LIS_SUCCESS",
  GET_ITEM_TAB_LIST_SUCCESS: "GET_ITEM_TAB_LIST_SUCCESS",

  GET_USER_TAB_LIST_FAILURE: "GET_USER_TAB_LIST_FAILURE",
  GET_OU_TAB_LIST_FAILURE: "GET_OU_TAB_LIST_FAILURE",
  GET_BR_TAB_LIST_FAILURE: "GET_BR_TAB_LIST_FAILURE",
  GET_ENTITLEMENT_TAB_LIST_FAILURE: "GET_ENTITLEMENT_TAB_LIST_FAILURE",
  GET_ACCOUNT_TAB_LIST_FAILURE: "GET_ACCOUNT_TAB_LIST_FAILURE",
  GET_TECHNICAL_USER_TAB_LIST_FAILURE: "GET_TECHNICAL_USER_TAB_LIST_FAILURE",
  GET_ITEM_TAB_LIST_FAILURE: "GET_ITEM_TAB_LIST_FAILURE",

  GET_ENTITLEMENTS_GIVEN_USER: "GET_ENTITLEMENTS_GIVEN_USER",
  GET_ENTITLEMENTS_GIVEN_USER_SUCCESS: "GET_ENTITLEMENTS_GIVEN_USER_SUCCESS",
  GET_ENTITLEMENTS_GIVEN_USER_FAILURE: "GET_ENTITLEMENTS_GIVEN_USER_FAILURE",

  GET_USERS_GIVEN_ENTITLEMENT: "GET_USERS_GIVEN_ENTITLEMENT",
  GET_USERS_GIVEN_ENTITLEMENT_SUCCESS: "GET_USERS_GIVEN_ENTITLEMENT_SUCCESS",
  GET_USERS_GIVEN_ENTITLEMENT_FAILURE: "GET_USERS_GIVEN_ENTITLEMENT_FAILURE",

  GET_ENTITLEMENTS_GIVEN_OU: "GET_ENTITLEMENTS_GIVEN_OU",
  GET_ENTITLEMENTS_GIVEN_OU_SUCCESS: "GET_ENTITLEMENTS_GIVEN_OU_SUCCESS",
  GET_ENTITLEMENTS_GIVEN_OU_FAILURE: "GET_ENTITLEMENTS_GIVEN_OU_FAILURE",

  GET_ENTITLEMENTS_GIVEN_BR: "GET_ENTITLEMENTS_GIVEN_BR",
  GET_ENTITLEMENTS_GIVEN_BR_SUCCESS: "GET_ENTITLEMENTS_GIVEN_BR_SUCCESS",
  GET_ENTITLEMENTS_GIVEN_BR_FAILURE: "GET_ENTITLEMENTS_GIVEN_BR_FAILURE",

  GET_ACCOUNTS_GIVEN_USER: "GET_ACCOUNTS_GIVEN_USER",
  GET_ACCOUNTS_GIVEN_USER_SUCCESS: "GET_ACCOUNTS_GIVEN_USER_SUCCESS",
  GET_ACCOUNTS_GIVEN_USER_FAILURE: "GET_ACCOUNTS_GIVEN_USER_FAILURE",

  GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT:
    "GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT",
  GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_SUCCESS:
    "GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_SUCCESS",
  GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_FAILURE:
    "GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_FAILURE",

  GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER:
    "GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER",
  GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_SUCCESS:
    "GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_SUCCESS",
  GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_FAILURE:
    "GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_FAILURE",

  MASSIVE_OPERATIONS_ITEM_REQUEST: "MASSIVE_OPERATIONS_ITEM_REQUEST",
  MASSIVE_OPERATIONS_ITEM_REQUEST_SUCCESS:
    "MASSIVE_OPERATIONS_ITEM_REQUEST_SUCCESS",
  MASSIVE_OPERATIONS_ITEM_REQUEST_FAILURE:
    "MASSIVE_OPERATIONS_ITEM_REQUEST_FAILURE",

  SET_EDIT_REVISOR_ITEM: "SET_EDIT_REVISOR_ITEM",
  SET_EDIT_REVISOR_AGGREGATE_OU_ITEMS: "SET_EDIT_REVISOR_AGGREGATE_OU_ITEMS",
  SET_EDIT_REVISOR_AGGREGATE_BR_ITEMS: "SET_EDIT_REVISOR_AGGREGATE_BR_ITEMS",
  SET_EDIT_REVISOR_AGGREGATE_USER_ITEMS:
    "SET_EDIT_REVISOR_AGGREGATE_USER_ITEMS",
  SET_EDIT_REVISOR_AGGREGATE_ENTITLEMENTS_ITEMS:
    "SET_EDIT_REVISOR_AGGREGATE_ENTITLEMENTS_ITEMS",
  SET_EDIT_REVISOR_AGGREGATE_TECHNICAL_USERS_ITEMS:
    "SET_EDIT_REVISOR_AGGREGATE_TECHNICAL_USERS_ITEMS",
};

export const setCampaignAccessRoleAction = (payload: string) => ({
  type: actionTypes.SET_CAMPAIGN_ACCESS_ROLE,
  payload,
});

export const setImpersonificationAction = (payload: string) => ({
  type: actionTypes.SET_IMPERSONIFICATION,
  payload,
});

export const certificationReferenceSetTriggerConfirmModal = (payload: any) => ({
  type: actionTypes.SET_TRIGGER_CONFIRM_MODAL_CERTIFICATION_REFERENCE,
  payload,
});

export const setSelectedCertification = (payload: {}) => ({
  type: actionTypes.SET_SELECTED_CERTIFICATION,
  payload,
});

export const setSelectedItemDetailAction = (payload: {}) => ({
  type: actionTypes.SELECT_ITEM_DETAIL,
  payload,
});

export const certificationRequest = (payload: any) => ({
  type: actionTypes.CERTIFICATION_REQUEST,
  payload,
});

export const certificationRequestSuccess = (payload: any) => ({
  type: actionTypes.CERTIFICATION_REQUEST_SUCCESS,
  payload,
});

export const certificationRequestFailure = (err: any) => ({
  type: actionTypes.CERTIFICATION_REQUEST_FAILURE,
  err,
});

export const getCertificationInfoAction = (payload: string) => ({
  type: actionTypes.GET_CAMPAIGN_INFO,
  payload,
});

export const getCertificationInfoSuccessAction = (payload: any) => ({
  type: actionTypes.GET_CAMPAIGN_INFO_SUCCESS,
  payload,
});

export const getCertificationInfoFailureAction = (payload: string) => ({
  type: actionTypes.GET_CAMPAIGN_INFO_FAILURE,
  payload,
});

export const getCampaignRevisorsAction = (payload: string) => ({
  type: actionTypes.GET_CAMPAIGN_REVISORS,
  payload,
});

export const getCampaignRevisorsSuccessAction = (payload: any) => ({
  type: actionTypes.GET_CAMPAIGN_REVISORS_SUCCESS,
  payload,
});

export const getCampaignRevisorsFailureAction = (payload: string) => ({
  type: actionTypes.GET_CAMPAIGN_REVISORS_FAILURE,
  payload,
});

export const selectItem = (payload: any) => ({
  type: actionTypes.SELECT_ITEM,
  payload,
});

export const editRevisorRequest = (payload: any) => ({
  type: actionTypes.GET_EDIT_REVISOR_REQUEST,
  payload,
});
export const editRevisorRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_EDIT_REVISOR_REQUEST_SUCCESS,
  payload,
});
export const editRevisorRequestFailure = (error: Error) => ({
  type: actionTypes.GET_EDIT_REVISOR_REQUEST_FAILURE,
  error,
});

export const editCampaignRequest = (payload: any) => ({
  type: actionTypes.EDIT_CAMPAIGN_REQUEST,
  payload,
});
export const editCampaignRequestSuccess = (payload: any) => ({
  type: actionTypes.EDIT_CAMPAIGN_REQUEST_SUCCESS,
  payload,
});
export const editCampaignRequestFailure = (error: Error) => ({
  type: actionTypes.EDIT_CAMPAIGN_REQUEST_FAILURE,
  error,
});

export const setConfirmExecution = (payload: {
  type: string;
  state: boolean;
  listIds: string[];
}) => ({
  type: actionTypes.SET_CONFIRM_EXECUTION,
  payload,
});

export const keepItemsRequest = (payload: {
  body: {
    items: string[];
    note: string;
  };
  actingAs?: string;
}) => ({
  type: actionTypes.KEEP_ITEMS_REQUEST,
  payload,
});

export const keepItemsRequestSuccess = (payload: string[]) => ({
  type: actionTypes.KEEP_ITEMS_REQUEST_SUCCESS,
  payload,
});

export const keepItemsRequestFailure = (error: any) => ({
  type: actionTypes.KEEP_ITEMS_REQUEST_FAILURE,
  error,
});

export const revokeItemsRequest = (payload: {
  body: {
    items: string[];
    note: string;
  };
  actingAs?: string;
}) => ({
  type: actionTypes.REVOKE_ITEMS_REQUEST,
  payload,
});

export const revokeItemsRequestSuccess = (payload: string[]) => ({
  type: actionTypes.REVOKE_ITEMS_REQUEST_SUCCESS,
  payload,
});

export const revokeItemsRequestFailure = (error: any) => ({
  type: actionTypes.REVOKE_ITEMS_REQUEST_FAILURE,
  error,
});

export const validateItemsRequest = (payload: {
  body: {
    items: string[];
    note: string;
  };
  actingAs?: string;
}) => ({
  type: actionTypes.VALIDATE_ITEMS_REQUEST,
  payload,
});

export const validateItemsRequestSuccess = (payload: string[]) => ({
  type: actionTypes.VALIDATE_ITEMS_REQUEST_SUCCESS,
  payload,
});

export const validateItemsRequestFailure = (error: any) => ({
  type: actionTypes.VALIDATE_ITEMS_REQUEST_FAILURE,
  error,
});

export const resetStateStepOne = () => ({
  type: actionTypes.RESET_STATE_STEP_ONE,
});

export const closeCertification = (payload: {
  recInstanceId: string;
  body: string;
}) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION,
  payload,
});

export const closeCertificationSuccess = (payload: string[]) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION_SUCCESS,
  payload,
});

export const closeCertificationFailure = (err: any) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION_FAILURE,
  err,
});

export const sendCertificationReminder = (payload: string) => ({
  type: actionTypes.FETCH_SEND_CERTIFICATION_REMINDER,
  payload,
});

export const sendCertificationReminderSuccess = (payload: string[]) => ({
  type: actionTypes.FETCH_SEND_CERTIFICATION_REMINDER_SUCCESS,
  payload,
});

export const sendCertificationReminderFailure = (err: any) => ({
  type: actionTypes.FETCH_SEND_CERTIFICATION_REMINDER_FAILURE,
  err,
});

export const closeCertificationItem = (payload: string) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION_ITEM,
  payload,
});

export const closeCertificationItemSuccess = (payload: string[]) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION_ITEM_SUCCESS,
  payload,
});

export const closeCertificationItemFailure = (err: any) => ({
  type: actionTypes.FETCH_CLOSE_CERTIFICATION_ITEM_FAILURE,
  err,
});

export const updateRevisor = (payload: {
  itemIds: string[];
  revisorCode: string;
}) => ({
  type: actionTypes.FETCH_UPDATE_REVISOR,
  payload,
});
export const updateRevisorSuccess = (payload: string[]) => ({
  type: actionTypes.FETCH_UPDATE_REVISOR_SUCCESS,
  payload,
});
export const updateRevisorFailure = (err: any) => ({
  type: actionTypes.FETCH_UPDATE_REVISOR_FAILURE,
  err,
});
export const updateAggregateOuRevisorRequest = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_OU_REVISOR_REQUEST,
  payload,
});
export const updateAggregateOuRevisorRequestSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_OU_REVISOR_REQUEST_SUCCESS,
  payload,
});
export const updateAggregateOuRevisorRequestFailure = (error: Error) => ({
  type: actionTypes.UPDATE_AGGREGATE_OU_REVISOR_REQUEST_FAILURE,
  error,
});
export const updateAggregateUserRevisorRequest = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_USER_REVISOR_REQUEST,
  payload,
});
export const updateAggregateUserRevisorRequestSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_USER_REVISOR_REQUEST_SUCCESS,
  payload,
});
export const updateAggregateUserRevisorRequestFailure = (error: Error) => ({
  type: actionTypes.UPDATE_AGGREGATE_USER_REVISOR_REQUEST_FAILURE,
  error,
});
export const updateAggregateTechnicalUserRevisorRequest = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST,
  payload,
});
export const updateAggregateTechnicalUserRevisorRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_SUCCESS,
  payload,
});
export const updateAggregateTechnicalUserRevisorRequestFailure = (
  error: Error
) => ({
  type: actionTypes.UPDATE_AGGREGATE_TECH_USER_REVISOR_REQUEST_FAILURE,
  error,
});

export const updateAggregateBrEntRevisorRequest = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST,
  payload,
});
export const updateAggregateBrEntRevisorRequestSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_SUCCESS,
  payload,
});
export const updateAggregateBrEntRevisorRequestFailure = (error: Error) => ({
  type: actionTypes.UPDATE_AGGREGATE_BR_ENT_REVISOR_REQUEST_FAILURE,
  error,
});

export const reOpenItem = (payload: string) => ({
  type: actionTypes.FETCH_REOPEN_ITEM,
  payload,
});

export const reOpenItemSuccess = (payload: string[]) => ({
  type: actionTypes.FETCH_REOPEN_ITEM_SUCCESS,
  payload,
});

export const reOpenItemFailure = (err: any) => ({
  type: actionTypes.FETCH_REOPEN_ITEM_FAILURE,
  err,
});

export const setIsCurrentUserAdminAction = (payload: boolean) => ({
  type: actionTypes.SET_IS_CURRENT_USER_ADMIN,
  payload,
});

export const setIsCurrentUserSupervisorAction = (payload: boolean) => ({
  type: actionTypes.SET_IS_CURRENT_USER_SUPERVISOR,
  payload,
});

export const editPerimeterUsersPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.EDIT_PERIMETER_USERS_PERIMETER_REQUEST,
  payload,
});

export const editPerimeterSetAddedUsersPerimeter = (payload: any) => ({
  type: actionTypes.EDIT_PERIMETER_SET_ADDED_USERS_PERIMETER,
  payload,
});

export const editPerimeterUsersSetTabSelected = (
  payload: any,
  tab: string
) => ({
  type: actionTypes.EDIT_PERIMETER_USERS_SET_TAB_SELECTED,
  payload,
  tab,
});

export const editPerimeterUsersPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.EDIT_PERIMETER_USERS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterUsersPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.EDIT_PERIMETER_USERS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const editPerimeterGroupsPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST,
  payload,
});

export const editPerimeterSetAddedGroupsPerimeter = (payload: any) => ({
  type: actionTypes.EDIT_PERIMETER_SET_ADDED_GROUPS_PERIMETER,
  payload,
});

export const editPerimeterSetTabSelected = (payload: any, tab: string) => ({
  type: actionTypes.EDIT_PERIMETER_SET_TAB_SELECTED,
  payload,
  tab,
});

export const editPerimeterGroupsPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterGroupsPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.EDIT_PERIMETER_GROUPS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const setAddedSupervisorsCertificationReference = (payload: any) => ({
  type: actionTypes.SET_ADDED_SUPERVISORS_CERTIFICATION_REFERENCE,
  payload,
});

export const supervisorsRequestCertificationReference = (payload?: any) => ({
  type: actionTypes.SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE,
  payload,
});

export const supervisorsRequestCertificationReferenceSuccess = (
  payload: any
) => ({
  type: actionTypes.SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_SUCCESS,
  payload,
});

export const supervisorsRequestCertificationReferenceFailure = (
  error: Error
) => ({
  type: actionTypes.SUPERVISORS_REQUEST_CERTIFICATION_REFERENCE_FAILURE,
  error,
});

export const editPerimeterOwnershipSetAddedEntitlementsPerimeter = (
  payload: any
) => ({
  type: actionTypes.EDIT_PERIMETER_OWNERSHIP_SET_ADDED_ENTITLEMENTS_PERIMETER,
  payload,
});

export const editPerimeterOwnershipSetTabSelected = (
  payload: any,
  tab: string
) => ({
  type: actionTypes.EDIT_PERIMETER_OWNERSHIP_SET_TAB_SELECTED,
  payload,
  tab,
});

export const editPerimeterOwnershipEntitlementsPerimeterRequest = (
  payload: any | null
) => ({
  type: actionTypes.EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST,
  payload,
});

export const editPerimeterOwnershipEntitlementsPerimeterRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterOwnershipEntitlementsPerimeterRequestFailure = (
  error: Error
) => ({
  type: actionTypes.EDIT_PERIMETER_OWNERSHIP_ENTITLEMENTS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const editPerimeterOwnershipSetTriggerConfirmModal = (payload: any) => ({
  type: actionTypes.SET_TRIGGER_CONFIRM_MODAL_EDIT_PERIMETER,
  payload,
});

export const editPerimeterBrPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.EDIT_PERIMETER_BR_PERIMETER_REQUEST,
  payload,
});

export const editPerimeterBrPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.EDIT_PERIMETER_BR_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterBrPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.EDIT_PERIMETER_BR_PERIMETER_REQUEST_FAILURE,
  error,
});

export const setAddedBrPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_BR_PERIMETER,
  payload,
});

export const editPerimeterApplicationsPerimeterRequest = (
  payload: any | null
) => ({
  type: actionTypes.EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST,
  payload,
});

export const editPerimeterApplicationsPerimeterRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterApplicationsPerimeterRequestFailure = (
  error: Error
) => ({
  type: actionTypes.EDIT_PERIMETER_APPLICATIONS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const setAddedApplicationsPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_APPLICATIONS_PERIMETER,
  payload,
});

export const editPerimeterTechnicalUsersPerimeterRequest = () => ({
  type: actionTypes.EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST,
});

export const editPerimeterTechnicalUsersPerimeterRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const editPerimeterTechnicalUsersPerimeterRequestFailure = (
  error: Error
) => ({
  type: actionTypes.EDIT_PERIMETER_TECHNICAL_USER_PERIMETER_REQUEST_FAILURE,
  error,
});

export const setAddedTechnicalUsersPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_TECHNICAL_USERS_PERIMETER,
  payload,
});

export const getUserTabListAction = (payload: any) => ({
  type: actionTypes.GET_USER_TAB_LIST,
  payload,
});
export const getUserTabListActionSuccess = (
  payload: IGetUserTabListResponse
) => ({
  type: actionTypes.GET_USER_TAB_LIST_SUCCESS,
  payload,
});
export const getUserTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_USER_TAB_LIST_FAILURE,
  error,
});

export const getOUTabListAction = (payload: any) => ({
  type: actionTypes.GET_OU_TAB_LIST,
  payload,
});
export const getOUTabListActionSuccess = (payload: IGetOUTabListResponse) => ({
  type: actionTypes.GET_OU_TAB_LIST_SUCCESS,
  payload,
});
export const getOUTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_OU_TAB_LIST_FAILURE,
  error,
});

export const getBRTabListAction = (payload: any) => ({
  type: actionTypes.GET_BR_TAB_LIST,
  payload,
});
export const getBRTabListActionSuccess = (payload: IGetBRTabListResponse) => ({
  type: actionTypes.GET_BR_TAB_LIST_SUCCESS,
  payload,
});
export const getBRTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_BR_TAB_LIST_FAILURE,
  error,
});

export const getEntitlementTabListAction = (payload: any) => ({
  type: actionTypes.GET_ENTITLEMENT_TAB_LIST,
  payload,
});
export const getEntitlementTabListActionSuccess = (
  payload: IGetEntitlementTabListResponse
) => ({
  type: actionTypes.GET_ENTITLEMENT_TAB_LIST_SUCCESS,
  payload,
});
export const getEntitlementTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_ENTITLEMENT_TAB_LIST_FAILURE,
  error,
});

export const getAccountTabListAction = (payload: any) => ({
  type: actionTypes.GET_ACCOUNT_TAB_LIST,
  payload,
});
export const getAccountTabListActionSuccess = (
  payload: IGetAccountTabListResponse
) => ({
  type: actionTypes.GET_ACCOUNT_TAB_LIST_SUCCESS,
  payload,
});
export const getAccountTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_ACCOUNT_TAB_LIST_FAILURE,
  error,
});

export const getTechnicalUserTabListAction = (payload: any) => ({
  type: actionTypes.GET_TECHNICAL_USER_TAB_LIST,
  payload,
});
export const getTechnicalUserTabListActionSuccess = (
  payload: IGetTechnicalUserTabListResponse
) => ({
  type: actionTypes.GET_TECHNICAL_USER_TAB_LIST_SUCCESS,
  payload,
});
export const getTechnicalUserTabListActionFailure = (error: Error) => ({
  type: actionTypes.GET_TECHNICAL_USER_TAB_LIST_FAILURE,
  error,
});

export const getEntitlementsGivenUserAction = (payload: any) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_USER,
  payload,
});
export const getEntitlementsGivenUserActionSuccess = (
  payload: IEntitlementsGivenUserResponse
) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_USER_SUCCESS,
  payload,
});
export const getEntitlementsGivenUserActionFailure = (error: Error) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_USER_FAILURE,
  error,
});

export const getUsersGivenEntitlementAction = (payload: any) => ({
  type: actionTypes.GET_USERS_GIVEN_ENTITLEMENT,
  payload,
});
export const getUsersGivenEntitlementActionSuccess = (
  payload: IUsersGivenEntitlementResponse
) => ({
  type: actionTypes.GET_USERS_GIVEN_ENTITLEMENT_SUCCESS,
  payload,
});
export const getUsersGivenEntitlementActionFailure = (error: Error) => ({
  type: actionTypes.GET_USERS_GIVEN_ENTITLEMENT_FAILURE,
  error,
});

export const getEntitlementsGivenOuAction = (payload: any) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_OU,
  payload,
});
export const getEntitlementsGivenOuActionSuccess = (
  payload: IEntitlementsGivenOuResponse
) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_OU_SUCCESS,
  payload,
});
export const getEntitlementsGivenOuActionFailure = (error: Error) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_OU_FAILURE,
  error,
});

export const getEntitlementsGivenBrAction = (payload: any) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_BR,
  payload,
});
export const getEntitlementsGivenBrActionSuccess = (
  payload: IEntitlementsGivenBrResponse
) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_BR_SUCCESS,
  payload,
});
export const getEntitlementsGivenBrActionFailure = (error: Error) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_BR_FAILURE,
  error,
});

export const getAccountsGivenUserAction = (payload: any) => ({
  type: actionTypes.GET_ACCOUNTS_GIVEN_USER,
  payload,
});
export const getAccountsGivenUserActionSuccess = (
  payload: IAccountsGivenUserResponse
) => ({
  type: actionTypes.GET_ACCOUNTS_GIVEN_USER_SUCCESS,
  payload,
});
export const getAccountsGivenUserActionFailure = (error: Error) => ({
  type: actionTypes.GET_ACCOUNTS_GIVEN_USER_FAILURE,
  error,
});

export const getTechnicalUsersGivenEntitlementAction = (payload: any) => ({
  type: actionTypes.GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT,
  payload,
});
export const getTechnicalUsersGivenEntitlementActionSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_SUCCESS,
  payload,
});
export const getTechnicalUsersGivenEntitlementActionFailure = (
  error: Error
) => ({
  type: actionTypes.GET_TECHNICAL_USERS_GIVEN_ENTITLEMENT_FAILURE,
  error,
});

export const getEntitlementsGivenTechnicalUserAction = (payload: any) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER,
  payload,
});
export const getEntitlementsGivenTechnicalUserActionSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_SUCCESS,
  payload,
});
export const getEntitlementsGivenTechnicalUserActionFailure = (
  error: Error
) => ({
  type: actionTypes.GET_ENTITLEMENTS_GIVEN_TECHNICAL_USER_FAILURE,
  error,
});

export const massiveOperationsItemsRequest = (payload: {
  instanceId: string;
  endpoint: string;
  body: IFetchMassiveBody;
}) => ({
  type: actionTypes.MASSIVE_OPERATIONS_ITEM_REQUEST,
  payload,
});
export const massiveOperationsItemsRequestSuccess = (payload: any) => ({
  type: actionTypes.MASSIVE_OPERATIONS_ITEM_REQUEST_SUCCESS,
  payload,
});
export const massiveOperationsItemsRequestFailure = (error: any) => ({
  type: actionTypes.MASSIVE_OPERATIONS_ITEM_REQUEST_FAILURE,
  error,
});

export const setEditRevisorItemAction = (payload: any) => ({
  type: actionTypes.SET_EDIT_REVISOR_ITEM,
  payload,
});
export const setEditRevisorAggregateOuItemsAction = (payload: any) => ({
  type: actionTypes.SET_EDIT_REVISOR_AGGREGATE_OU_ITEMS,
  payload,
});
export const setEditRevisorAggregateBusinessRoleItemsAction = (
  payload: any
) => ({
  type: actionTypes.SET_EDIT_REVISOR_AGGREGATE_BR_ITEMS,
  payload,
});
export const setEditRevisorAggregateUserItemsAction = (payload: any) => ({
  type: actionTypes.SET_EDIT_REVISOR_AGGREGATE_USER_ITEMS,
  payload,
});
export const setEditRevisorAggregateEntitlementItemsAction = (
  payload: any
) => ({
  type: actionTypes.SET_EDIT_REVISOR_AGGREGATE_ENTITLEMENTS_ITEMS,
  payload,
});
export const setEditRevisorAggregateTechnicalUserItemsAction = (
  payload: any
) => ({
  type: actionTypes.SET_EDIT_REVISOR_AGGREGATE_TECHNICAL_USERS_ITEMS,
  payload,
});
